import moment from "moment"
import 'moment-timezone'

const filters = {

    contactAddress(c) {
        return (c.address_1 || '') + ' ' + (c.address_2 || '') + ' ' + (c.city || '') + ' ' + (c.state || '')
    },

    nl2br(s){
        if (!s) return ''

        return (s + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')
    },

    stripTags(str){
        return (str || '').replace(/(<([^>]+)>)/ig,'')
    },

    limit(str, limit){
        let slicedString = (str || '').slice(0, limit)

        if (str.length > limit) {
            return slicedString + '...'
        }

        return slicedString;
    },

    ucfirst(string){
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    startCase(str){
        return _.startCase(str)
    },

    yesNo(bool){
        return bool ? 'Yes' : 'No'
    },

    percentage(a, b){
        a = parseFloat(a)
        b = parseFloat(b)

        if (b === 0) return '–'
        return ((a/b)*100).toFixed(2) + '%'
    },

    readableSize(size){
        size = parseInt(size)

        let units = 'B';

        if(size > (1024 * 1024 * 1024)) {
            size /= 1024 * 1024 * 1024
            units = 'GB'
        }

        if (size > 1024 * 1024) {
            size /= 1024*1024
            units = 'MB'
        }

        if (size > 1024) {
            size /= 1024
            units = 'KB'
        }

        return size.toFixed(2) + ' ' + units
    },

    date(timestamp, format = 'MM/DD/YYYY'){
        return timestamp ? moment(timestamp).format(format) : null
    },

    datetime(timestamp){
        return timestamp ? moment(timestamp).format('MM/DD/YYYY hh:mm a') : null
    },

    time(timestamp){
        return timestamp ? moment(timestamp).format('hh:mma') : null
    },

    note_date(timestamp){
        return timestamp ? moment(timestamp).format('MMMM D, YYYY [at] h:mm A') : null
    },

    ago(timestamp){
        return moment(timestamp).tz('America/New_York').fromNow()
    },

    toFixed(number, decimals = 2){
        return !isNaN(number) && number !== null ? parseFloat(number).toFixed(decimals): number
    },

    valueOrDefault(value, _default = 'Not Specified'){
        return value ? value : _default
    },

    projectBBL(project){
        let borough = project.borough ? project.borough : 'xx',
            block = project.block ? project.block : 'xx',
            lot = project.log ? project.lot : 'xx'

        return `${borough}-${block}-${lot}`
    },

    padEnd(str, length, symbol = ' '){
        return _.padEnd(str, length, symbol)
    },

    currency(value, currency = '$', decimals = 2){

            let digitsRE = /(\d{3})(?=\d)/g
            value = parseFloat(value)

            if (!isFinite(value) || (!value && value !== 0)) {
                return null
            }

            let stringified = Math.abs(value).toFixed(decimals)
            let _int = decimals
                ? stringified.slice(0, -1 - decimals)
                : stringified
            let i = _int.length % 3
            let head = i > 0
                ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
                : ''
            let _float = decimals
                ? stringified.slice(-1 - decimals)
                : ''
            let sign = value < 0 ? '-' : ''

            return sign + currency + head +
                _int.slice(i).replace(digitsRE, '$1,') +
                _float

    }
}

export default filters;

// Vue.filter('contactAddress', c => {
//     return (c.address_1 || '') + ' ' + (c.address_2 || '') + ' ' + (c.city || '') + ' ' + (c.state || '')
// })
//
// Vue.filter('nl2br', s => {
//     if (!s) return ''
//
//     return (s + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')
// })
//
// Vue.filter('stripTags', str => (str || '').replace(/(<([^>]+)>)/ig,''))
//
// Vue.filter('limit', (str, limit) => {
//     let slicedString = (str || '').slice(0, limit)
//
//     if (str.length > limit) {
//         return slicedString + '...'
//     }
//
//     return slicedString;
// })
//
// Vue.filter('ucfirst', (string) => {
//     return string.charAt(0).toUpperCase() + string.slice(1);
// })
//
// Vue.filter('startCase', str => _.startCase(str))
//
// Vue.filter('yesNo', bool => bool ? 'Yes' : 'No')
//
// Vue.filter('percentage', (a, b) => {
//     a = parseFloat(a)
//     b = parseFloat(b)
//
//     if (b == 0) return '–'
//     return ((a/b)*100).toFixed(2) + '%'
// })
//
// Vue.filter('readableSize', (size) => {
//     size = parseInt(size)
//
//     var units = 'B'
//
//     if(size > (1024 * 1024 * 1024)) {
//         size /= 1024 * 1024 * 1024
//         units = 'GB'
//     }
//
//     if (size > 1024 * 1024) {
//         size /= 1024*1024
//         units = 'MB'
//     }
//
//     if (size > 1024) {
//         size /= 1024
//         units = 'KB'
//     }
//
//     return size.toFixed(2) + ' ' + units
// })
//
// Vue.filter('date', (timestamp, format = 'MM/DD/YYYY') => timestamp ? moment(timestamp).format(format) : null)
// Vue.filter('datetime', timestamp => timestamp ? moment(timestamp).format('MM/DD/YYYY hh:mm a') : null)
// Vue.filter('time', timestamp => timestamp ? moment(timestamp).format('hh:mma') : null)
// Vue.filter('note_date', timestamp => timestamp ? moment(timestamp).format('MMMM D, YYYY [at] h:mm A') : null)
// Vue.filter('ago', timestamp => moment(timestamp).tz('America/New_York').fromNow())
//
// Vue.filter('toFixed', (number, decimals = 2) => !isNaN(number) && number !== null ? parseFloat(number).toFixed(decimals): number)
//
// Vue.filter('valueOrDefault', (value, _default = 'Not Specified') => value ? value : _default)
//
// Vue.filter('projectBBL', project => {
//     let borough = project.borough ? project.borough : 'xx',
//         block = project.block ? project.block : 'xx',
//         lot = project.log ? project.lot : 'xx'
//
//     return `${borough}-${block}-${lot}`
// })
//
// Vue.filter('padEnd', (str, length, symbol = ' ') => _.padEnd(str, length, symbol))
//
// // https://github.com/freearhey/vue2-filters/blob/dev/src/other/currency.js
// Vue.filter('currency', (value, currency = '$', decimals = 2) => {
//     let digitsRE = /(\d{3})(?=\d)/g
//     value = parseFloat(value)
//
//     if (!isFinite(value) || (!value && value !== 0)) {
//         return null
//     }
//
//     let stringified = Math.abs(value).toFixed(decimals)
//     let _int = decimals
//         ? stringified.slice(0, -1 - decimals)
//         : stringified
//     let i = _int.length % 3
//     let head = i > 0
//         ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
//         : ''
//     let _float = decimals
//         ? stringified.slice(-1 - decimals)
//         : ''
//     let sign = value < 0 ? '-' : ''
//
//     return sign + currency + head +
//         _int.slice(i).replace(digitsRE, '$1,') +
//         _float
// })
